import React, { FC, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
// mui components
import { Grid } from '@mui/material';
// components
import Checkbox from 'components/checkbox';
// types
import { TFileCabinetRole } from 'redux-store/api/file-cabinet';
// helpers
import { capitalizeFirstLetter } from 'utils/helpers/capitalizeFirstLetterHelper';
// styles
import { styles } from './styles';

type RoleProps = {
  index: number;
  role: TFileCabinetRole;
  adminCheckedByDefault?: boolean;
};

const Role: FC<RoleProps> = ({ index, role, adminCheckedByDefault = true }) => {
  const form = useFormContext();

  const viewChangeHandler = useCallback(
    (event) => {
      const { id, name } = role;

      if (event.target.checked === true) {
        form.setValue(`roles.${index}`, {
          id,
          name,
          permissions: { ...role.permissions, canRead: event.target.checked },
        });
      }

      if (event.target.checked === false) {
        form.setValue(`roles.${index}`, {
          id,
          name,
          permissions: {
            canRead: event.target.checked,
            canAddUpdate: event.target.checked,
            canDelete: event.target.checked,
          },
        });
      }
    },
    [role]
  );

  const addEditChangeHandler = useCallback(
    (event) => {
      const { id, name } = role;

      form.setValue(`roles.${index}`, {
        id,
        name,
        permissions: { ...role.permissions, canAddUpdate: event.target.checked },
      });
    },
    [role]
  );

  const deleteChangeHandler = useCallback(
    (event) => {
      const { id, name } = role;

      form.setValue(`roles.${index}`, {
        id,
        name,
        permissions: { ...role.permissions, canDelete: event.target.checked },
      });
    },
    [role]
  );
  const isAdminRole = adminCheckedByDefault && role?.name === 'ADMIN';
  const isDisabled = isAdminRole;

  const isViewChecked = isAdminRole ? true : !!role?.permissions?.canRead;
  const isAddEditChecked = isAdminRole ? true : !!role?.permissions?.canAddUpdate;
  const isDeleteChecked = isAdminRole ? true : !!role?.permissions?.canDelete;

  return (
    <Grid sx={styles.tableRow} className="role-row">
      <Grid sx={styles.tableRoleName}>{capitalizeFirstLetter(role?.name) || '-'}</Grid>

      <Grid sx={styles.checkboxContainer}>
        <Checkbox
          onChange={viewChangeHandler}
          checked={isViewChecked}
          disabled={isDisabled}
        />
      </Grid>

      <Grid sx={styles.checkboxContainer}>
        <Checkbox
          onChange={addEditChangeHandler}
          checked={isAddEditChecked}
          disabled={!role?.permissions?.canRead || isDisabled}
        />
      </Grid>

      <Grid sx={styles.checkboxContainer}>
        <Checkbox
          onChange={deleteChangeHandler}
          checked={isDeleteChecked}
          disabled={!role?.permissions?.canRead || isDisabled}
        />
      </Grid>
    </Grid>
  );
};

export default Role;
